import mixpanel from "mixpanel-browser";

export const analytics = (type: string, data?: any) => {
  try {
    mixpanel.track(type, data);
  } catch (error) {
    console.error("mixpanel error: ", error);
  }
};
